import { formatMeasurementLabel } from "../../../../../../../../utils/measurement-label";
import type { IKeyphasorAutocompleteResponse, IMeasureAutocompleteResponse, IParameterOption } from "../../interfaces";
import { PARAMETER_TYPE } from "../table/interfaces";

export const createCommonParameterOptions = (
  parameters: IKeyphasorAutocompleteResponse[],
  group: PARAMETER_TYPE.keyphasor | PARAMETER_TYPE.parameter,
): IParameterOption[] =>
  parameters
    .filter(parameter => parameter.id !== null)
    .map(({ id, title, description }) => ({
      id: `${group}_${id}`,
      title: formatMeasurementLabel(title, description),
      group,
    }));

export const createMeasureOptions = (
  measures: IMeasureAutocompleteResponse[],
): Array<IParameterOption & { ids: number[] }> =>
  measures
    .filter((measure): measure is IMeasureAutocompleteResponse & { title: string } => measure.title !== null)
    .map(({ title, description, useValue2, ids }) => ({
      id: title,
      title: formatMeasurementLabel(title, description),
      useValue2,
      group: PARAMETER_TYPE.point,
      ids,
    }));
